var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('navbar',{directives:[{name:"show",rawName:"v-show",value:(!_vm.contentOnly),expression:"!contentOnly"}],staticStyle:{"margin-bottom":"100px"}})],1),_c('router-view',{staticStyle:{"margin-bottom":"100px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }